/*
 * Populates the "buy a used copy" part of each Bookabaloo Marketplace box
 * (snippets/bookloop-cta.liquid). Scoped per [data-bookloop] element so the
 * box can appear more than once on a page (desktop + mobile) without conflict.
 */
(function () {
  var boxes = document.querySelectorAll('[data-bookloop]:not([data-bookloop-done])');

  Array.prototype.forEach.call(boxes, function (box) {
    box.setAttribute('data-bookloop-done', '1');
    var isbn = box.getAttribute('data-isbn');
    if (!isbn) return;

    fetch('/apps/baloo/bookloop/used?isbn=' + encodeURIComponent(isbn))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.count) return;

        var used = box.querySelector('.bookloop-box__used');
        var toggle = box.querySelector('.bookloop-box__used-toggle');
        var panel = box.querySelector('.bookloop-box__used-panel');
        if (!used || !toggle || !panel) return;

        var label = d.count === 1 ? '1 used copy' : d.count + ' used copies';
        toggle.textContent = label + ' from $' + d.cheapest;

        var html = '';
        (d.listings || []).forEach(function (l) {
          html += '<div class="bookloop-box__listing"><span>' + l.condition + '</span><strong>$' + l.price + '</strong></div>';
        });
        panel.innerHTML = html;

        toggle.addEventListener('click', function () {
          var willOpen = panel.hidden;
          panel.hidden = !willOpen;
          toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });

        used.hidden = false;
      })
      .catch(function () {});
  });
})();
